import FertilityChart from "./fertility-chart.vue";

export default FertilityChart;



// WEBPACK FOOTER //
// ./src/components/_charts/fertility/index.js